import lightFormat from "date-fns/lightFormat";
import parseDateYmd from "lib/utils/parseDateYmd";

export default function formatDateOrReturnHyphen(value?: string) {
  if (!value) {
    return "-";
  }

  return lightFormat(parseDateYmd(value), "dd/MM/yyyy");
}
